// DentiCision official brand marks (designer-provided artwork).
export const BRAND = { navy: "#0B2545", blue: "#1C6FE3", teal: "#16B5A6", grey: "#94A3B8" };

const LOGO_FULL = "/brand/denticision-logo-notag.png";
const LOGO_SYMBOL = "/brand/denticision-symbol-official.png";

/** Symbol only (converging clinical factors → decision node). Works on light & dark. */
export function LogoSymbol({ size = 40, className = "" }) {
  return (
    <img
      src={LOGO_SYMBOL}
      alt="DentiCision"
      style={{ height: size, width: "auto" }}
      className={className}
      draggable={false}
    />
  );
}

/** Full stacked lockup (symbol + wordmark + tagline). `size` = rendered height in px. */
export function LogoHorizontal({ size = 48, className = "" }) {
  return (
    <img
      src={LOGO_FULL}
      alt="DentiCision — Clinical Decision Support for Dentistry"
      style={{ height: size, width: "auto" }}
      className={className}
      draggable={false}
    />
  );
}
